import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSitename'
})
export class FormatSitenamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Step 1: Remove 'www.' if present
    let domain = value.replace(/^www\./, '');

    // Step 2: Capitalize the first letter
    return domain.charAt(0).toUpperCase() + domain.slice(1);
  }
}